var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Text } from "../typography";
import useCheckBoxStyles from "./use-styles-checkbox";
import useCheckbox from "./use-checkbox";
import { CheckboxContainer, HiddenCheckboxInput, StyledCheckbox, StyledLabel, LabelText, StyledIcon, AccessibleArea, } from "./styled";
export var Checkbox = forwardRef(function (_a, ref) {
    var checked = _a.checked, testId = _a["data-testid"], disabled = _a.disabled, className = _a.className, labelPosition = _a.labelPosition, label = _a.label, indeterminate = _a.indeterminate, margin = _a.margin, alignSelf = _a.alignSelf, iconProps = _a.iconProps, Label = _a.Label, props = __rest(_a, ["checked", 'data-testid', "disabled", "className", "labelPosition", "label", "indeterminate", "margin", "alignSelf", "iconProps", "Label"]);
    var styles = useCheckBoxStyles({ disabled: disabled }).styles;
    var _b = useCheckbox(__assign({ disabled: disabled, checked: checked, indeterminate: indeterminate }, props)), getInputProps = _b.getInputProps, getCheckBoxProps = _b.getCheckBoxProps;
    return (React.createElement(StyledLabel, { "data-testid": testId, disabled: disabled, className: className, margin: margin, alignSelf: alignSelf },
        React.createElement(AccessibleArea, null),
        label && labelPosition === "left" && (React.createElement(LabelText, { as: Label, left: true }, label)),
        React.createElement(CheckboxContainer, null,
            React.createElement(HiddenCheckboxInput, __assign({ "data-testid": "checkbox-input" }, getInputProps(ref, props))),
            React.createElement(StyledCheckbox, __assign({ "data-testid": "styled-checkbox" }, styles.styledCheckbox, getCheckBoxProps()),
                React.createElement(StyledIcon, __assign({ name: indeterminate ? "checkmark_partial_s" : "checkmark_s", disabled: disabled }, iconProps)))),
        label && labelPosition === "right" && (React.createElement(LabelText, { as: Label, right: true }, label))));
});
Checkbox.defaultProps = {
    labelPosition: "right",
    Label: Text,
};
